import { ApiError } from '@/lib/api-client';
import { ROLE_LABELS } from './constants';
import type { PublicUser } from './types';

/** Rotulo legivel para o papel do usuario. */
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}

/** Nome exibido no cabecalho (primeiro nome quando disponivel). */
export function displayName(user: Pick<PublicUser, 'name' | 'email'>): string {
  const first = user.name.trim().split(/\s+/)[0];
  return first && first.length > 0 ? first : user.email;
}

/** Extrai uma mensagem amigavel de qualquer erro vindo da API. */
export function toErrorMessage(error: unknown, fallback = 'Algo deu errado'): string {
  if (error instanceof ApiError) return error.message;
  if (error instanceof Error) return error.message;
  return fallback;
}

/**
 * Mensagem do login social. Quando o provider nao esta configurado no
 * servidor (sem GOOGLE_CLIENT_ID/SECRET), o Better Auth responde
 * PROVIDER_NOT_FOUND — que nao diz nada ao usuario final.
 */
export function toSocialErrorMessage(error: unknown): string {
  if (error instanceof ApiError && error.code === 'PROVIDER_NOT_FOUND') {
    return 'Login com Google indisponivel: provedor nao configurado neste ambiente.';
  }

  return toErrorMessage(error);
}

/**
 * True quando o erro representa "sem sessao utilizavel" - inclui a conta
 * inativada, que responde 403 mas nao deve manter o usuario logado.
 */
export function isUnauthenticated(error: unknown): boolean {
  if (!(error instanceof ApiError)) return false;

  return error.statusCode === 401 || error.code === 'USER_INACTIVE';
}
